module.exports = __webpack_public_path__ + "img/vodacom-trivia-soccer-bg-mobile.c136bd3e.png";